var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchasingFlowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 12.219h-6.386l-5.854-8.76a1.333 1.333 0 0 0-2.213 0l-5.853 8.76h-6.36c-.734 0-1.334.6-1.334 1.333 0 .12.014.24.054.36l3.386 12.36a2.652 2.652 0 0 0 2.56 1.947h17.334a2.68 2.68 0 0 0 2.573-1.947l3.387-12.36.04-.36c0-.733-.6-1.333-1.334-1.333zM15.987 6.605l3.746 5.614H12.24l3.747-5.614zM16 22.885a2.675 2.675 0 0 1-2.667-2.667c0-1.466 1.2-2.666 2.667-2.666 1.467 0 2.667 1.2 2.667 2.666 0 1.467-1.2 2.667-2.667 2.667z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasingFlowIcon);
export default __webpack_public_path__ + "static/media/purchasing-flow-icon.189a95f9e24b1d825e978171652b2ba9.svg";
export { ForwardRef as ReactComponent };